import objectIs from './objectIs';

/**
 * @returns {boolean} true if `objA[x] === objB[x]` for all `x`, and vice versa
 */
export default function shallowEqual(objA: unknown, objB: unknown) {
  if (objectIs(objA, objB)) {
    return true;
  }

  if (
    typeof objA !== 'object' ||
    objA === null ||
    typeof objB !== 'object' ||
    objB === null
  ) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    if (
      !Object.prototype.hasOwnProperty.call(objB, keysA[i]) ||
      !objectIs((objA as any)[keysA[i]], (objB as any)[keysA[i]])
    ) {
      return false;
    }
  }

  return true;
}
